//BASE
import Vue from 'vue'
import Vuex from 'vuex'
// import AreasStore from './components/AreasStore'
import { router } from './router'
import VueRouter from 'vue-router'
import App from './App.vue'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import Skeleton from 'vue-loading-skeleton';

//
import { BootstrapVue } from 'bootstrap-vue'
//
import Vue2TouchEvents from 'vue2-touch-events'
/////////////////////
Vue.use(Vuex)
// ROUTER
Vue.use(VueRouter)
// import { IonicVueRouter } from "@ionic/vue";
// Vue.use(IonicVueRouter);
//CONFIG
Vue.config.productionTip = false;
Vue.use(Ionic);
//
Vue.use(BootstrapVue)
//
Vue.use(Vue2TouchEvents)
//
Vue.use(Skeleton)
//
Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)



//IONIC
import Ionic from "@ionic/vue"
import "@ionic/core/css/core.css"
import "@ionic/core/css/ionic.bundle.css"

//FONT AWESOME -> https://dev.to/karlodelarosa3/font-awesome-5-as-a-component-in-vue-js-7ho
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fad } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


library.add(fab, fas, far, fal,fad);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.ignoredElements = [/^ion-/]



//SCSS
import './assets/scss/_main.scss'





//Initialisation de l'intercepteur de requetes
import {InitSecureRequestInterceptor} from "./interceptors/SecureRequestInterceptor";
InitSecureRequestInterceptor();

//INTEGRATION
new Vue({
  store: require('./components/AreasStore.js'),
  el: '#app',
  router,
  render: h => h(App)
})


